import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { RegisterMethod } from '@pflegia/types/common/enums/register-method.enum';

import { MULTIPOSTING_FUNNEL, SLIMMED_DOWN_FUNNEL_ROOT, TRANSPARENT_FUNNEL } from '@shared/application/constants';

const useRegisterMethod = () => {
  const {
    query: { accessPoint },
    pathname,
  } = useRouter();

  const registerMethod = useMemo(() => {
    if (accessPoint === TRANSPARENT_FUNNEL) return RegisterMethod.Transparent;
    if (pathname.includes(SLIMMED_DOWN_FUNNEL_ROOT) || accessPoint === MULTIPOSTING_FUNNEL) return RegisterMethod.Multiposting;
    return RegisterMethod.Funnel;
  }, [accessPoint, pathname]);

  return {
    isStandardFunnel: registerMethod === RegisterMethod.Funnel,
    isMultipostingFunnel: registerMethod === RegisterMethod.Multiposting,
    isTransparentFunnel: registerMethod === RegisterMethod.Transparent,
    registerMethod,
  };
};

export default useRegisterMethod;
